import { MandatePeriod } from '../objects/MandatePeriod';
import { OrganizationMissionList } from './OrganizationMissionList';

angular.module("tromanWeb").factory('organizationService', ['tromanServer', function (tromanServer) {

    var so = {};

    so.getMissions = function getMissions(mandatePeriod) {
        return tromanServer.Missions.search({
            MandatePeriodId: mandatePeriod.Id
        }).then(function (data) {
            return new OrganizationMissionList(mandatePeriod, data);
        });
    };

    so.selectDisplayMandate = function selectDisplayMandate(organization, mandatePeriodId) {
        if (organization.MandatePeriods == null || organization.MandatePeriods.length === 0) {
            return null;
        }

        let mp = null;

        if (mandatePeriodId != null) {
            mp = organization.MandatePeriods.find(x => x.Id === mandatePeriodId);
        }

        if (mp == null) {
            mp = organization.getCurrentMandate();
        }

        if (mp == null) {
            mp = organization.getLastMandate();
        }

        return mp;
    };

    so.nextMandate = function nextMandate(organization) {
        let ret = new MandatePeriod();

        let last = organization.getLastMandate();

        if (last != null) {
            if (last.End != null) {
                ret.Start = new Date(last.End.getFullYear(), last.End.getMonth(), last.End.getDate() + 1);
                var years = last.End.getFullYear() - last.Start.getFullYear();
                var months = last.End.getMonth() - last.Start.getMonth();
                var days = last.End.getDate() - last.Start.getDate();
                ret.End = new Date(ret.Start.getFullYear() + years, ret.Start.getMonth() + months, ret.Start.getDate() + days);
            } else {
                ret.Start = new Date(last.Start.getFullYear(), last.Start.getMonth(), last.Start.getDate() + 1);
                ret.End = null;
            }

            ret.DecisionClause = last.DecisionClause;
            ret.MemberCount = last.MemberCount;
            ret.SubstituteCount = last.SubstituteCount;
            ret.IsGroundForGratuity = last.IsGroundForGratuity;
            ret.HasPersonalSubstitutes = last.HasPersonalSubstitutes;
            ret.AllowSameDayOverlap = last.AllowSameDayOverlap;
            ret.HasDivisions = last.HasDivisions;
        }

        ret.Organization = organization;
        return ret;
    };

    return so;

}]);
